import { Component, ElementRef, Input, OnInit, AfterViewInit } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import { fromLonLat, toLonLat } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import VectorLayer from 'ol/layer/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import MapboxVector from 'ol/layer/MapboxVector';
import OSM from 'ol/source/OSM';

import {
  Select,
  Translate,
  defaults as defaultInteractions,
} from 'ol/interaction';

import 'ol/ol.css';
import 'ol/ol.css';
import { Fill, Icon, Stroke, Style, Text } from 'ol/style';
import { Cluster } from '../shared/Cluster.service';
import { Control, defaults as defaultControls, defaults } from 'ol/control';
import { stringify } from '@angular/compiler/src/util';
import { HttpRequest } from '../shared/HttpRequest.service';
import { Observable } from 'rxjs';

export const DEFAULT_HEIGHT = '500px';
export const DEFAULT_WIDTH = '500px';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {
  @Input() lat!: number;
  @Input() lon!: number;
  @Input() zoom!: number;
  @Input() width: string | number = DEFAULT_WIDTH;
  @Input() height: string | number = DEFAULT_HEIGHT;

  target: string = 'map-' + Math.random().toString(36).substring(2);
  map!: Map;
  public altezzaSchermo: any;

  private mapOutput!: HTMLOutputElement;


  constructor(private elementRef: ElementRef, private httpClient: HttpClient,
    private clusterService: Cluster, private httpRequest: HttpRequest) {
  }

  pronto: boolean = false;
  lastCluster: number = 10;

  obsProducts = new Object(this.httpClient.get(`${environment.apiUrl}/test/data`)
    .subscribe((geojson: any) => {
      this.products = geojson;
      console.log('[GeoJSON] Caricato:', geojson?.features?.length, 'feature');
    },
      (err) => console.error('[GeoJSON] ERRORE caricamento:', err),
      () => this.initMap()));
  // obsProducts = new Object(this.httpRequest.getFile("https://iimiyvu9s0.execute-api.eu-south-1.amazonaws.com/test/data").subscribe((data: JSON) => {
  //   this.products = data;
  // },
  //   (err) => console.error(err),
  //   () => this.initMap()));

  strproducts!: string;

  products: Object = new Object();

  filteredGeojson =
    {
      "type": "FeatureCollection",
      "crs": {
        "type": "name",
        "properties":
        {
          "name": "urn:ogc:def:crs:EPSG::3857"
        }
      },
      "features": []
    };

  ngOnInit(): void {
    this.mapOutput = this.elementRef.nativeElement.querySelector('#map');


    // Richiamo il metodo "filterMap"
    // ogni qualvolta si cambia il layer
    // da voler visualizzare
    // (ottengo quindi un'interazione
    // dal servizio "Cluster")
    this.clusterService.changeClusterEvent
      .subscribe(
        (value: number) => {
          this.filterMap(value);
        }
      );

    this.clusterService.changeHoverValueEvent
      .subscribe(
        (value: number) => {
          this.changeHoverValueMessage(value);
        }
      )
  }

  // Token Mapbox rimosso — si usa OpenFreeMap (gratuito, nessun token richiesto)

  vectorSource: any;
  vectorLayer: any;

  darkMode: boolean = true;

  ngAfterViewInit() {
    // Mostro la mappa in DOM
    this.mapOutput = this.elementRef.nativeElement.querySelector('#' + this.target);
    this.setSize();
  }

  // Un singolo VectorImageLayer per tutte le ~10k feature.
  // Le 10 categorie cluster sono distinte da una style function;
  // gli oggetti Style sono cacheati per evitare allocazioni per feature.
  private clusterLayer!: VectorImageLayer<VectorSource>;
  private clusterStyles: Style[] = [];
  private currentClusterFilter: number = -1;

  filteredSelectedFeature =
    {
      "type": "FeatureCollection",
      "crs": {
        "type": "name1",
        "properties":
        {
          "name": "urn:ogc:def:crs:EPSG::3857"
        }
      },
      "features": []
    };

  // Unicode icons: 🛰 = satellite view available, 🗺 = map view available
  private readonly ICON_SHOW_SATELLITE = '🛰';
  private readonly ICON_SHOW_MAP       = '🗺';
  layerToggleBtn: HTMLButtonElement | null = null;
  hidePolyBtn: HTMLButtonElement | null = null;
  polygonsVisible: boolean = true;

  // Mappatura CLUSTER → nome coltura (specchietto del backend)
  private readonly CROP_MAP: Record<number, string> = {
    0:  'Grano / Frumento',
    1:  'Mais / Granturco',
    2:  'Prati permanenti (uno o più sfalci)',
    3:  'Prati non permanenti da foraggio (loietto)',
    4:  'Vegetazione spontanea e incolti',
    5:  'Soia in successione a terreni in riposo',
    6:  'Sorgo in successione a cereali',
    7:  'Prati non permanenti non irrigati (medicai)',
    8:  'Doppio avvicendamento colturale',
    9:  'Barbabietola da zucchero',
  };

  getCropName(cluster: number): string {
    return this.CROP_MAP[cluster] ?? 'Coltura non classificata';
  }

  togglePolygons(): Control {
    const button = document.createElement('button');
    button.className = 'ol-hide-poly-btn';
    button.title = 'Nascondi/Mostra poligoni';
    button.textContent = '⬡';
    this.hidePolyBtn = button;

    const element = document.createElement('div');
    element.className = 'ol-hide-poly-div';
    element.appendChild(button);

    button.addEventListener('click', () => {
      this.polygonsVisible = !this.polygonsVisible;
      if (this.clusterLayer) {
        this.clusterLayer.setVisible(this.polygonsVisible);
      }
      button.classList.toggle('active', !this.polygonsVisible);
      button.title = this.polygonsVisible ? 'Nascondi poligoni' : 'Mostra poligoni';
    });

    return new Control({ element });
  }

  onChangeBgMap() {

    // RIMUOVO IL LAYER DEI CLUSTER per poterlo riposizionare sopra il nuovo background
    if (this.clusterLayer) {
      this.map.removeLayer(this.clusterLayer);
    }

    // RIMUOVO LA MAPPA IN BACKGROUND
    if (this.darkMode == true)
      this.map.removeLayer(this.darkModeMap);
    else
      this.map.removeLayer(this.geoMap);

    // AGGIUNGO LA MAPPA
    if (this.darkMode == true) {
      this.map.addLayer(this.geoMap);
      this.darkMode = false;
      if (this.layerToggleBtn) this.layerToggleBtn.textContent = this.ICON_SHOW_MAP;
    } else {
      this.map.addLayer(this.darkModeMap);
      this.darkMode = true;
      if (this.layerToggleBtn) this.layerToggleBtn.textContent = this.ICON_SHOW_SATELLITE;
    }

    // RIPRISTINO IL LAYER DEI CLUSTER SOPRA AL BACKGROUND
    if (this.clusterLayer) {
      this.map.addLayer(this.clusterLayer);
    }
  }

  changeMapBackground(): Control {
    var button = document.createElement('button');
    button.className = 'ol-change-map-btn';
    button.title = 'Cambia mappa';
    // Start in dark mode → icon hints at satellite (next action)
    button.textContent = '🛰';
    this.layerToggleBtn = button;

    var element = document.createElement('div');
    element.className = 'ol-change-map-div';
    element.appendChild(button);

    button.addEventListener('click', () => this.onChangeBgMap());

    return new Control({ element });
  }

  // MAPPA DARK MODE — OpenFreeMap (gratuito, nessun token richiesto)
  darkModeMap = new MapboxVector({
    styleUrl: 'https://tiles.openfreemap.org/styles/fiord'
  })

  // MAPPA SATELLITARE
  geoMap = new TileLayer({
    source: new XYZ({
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      maxZoom: 19
    })
  })

  initMap(): void {

    // console.log(this.products)

    // SELEZIONE DI UN AREA
    var select = new Select({
      style: new Style({
        stroke: new Stroke({
          color: 'rgb(235, 235, 235)',
          width: 4
        }),
        fill: new Fill({
          color: 'rgba(201, 201, 201, 0.6)'
        })
      })
    });

    // Inizializzo la mappa
    this.map = new Map({
      interactions: defaultInteractions().extend([select]),
      controls:
        defaultControls().extend([
          this.changeMapBackground(),
          this.togglePolygons()
        ]),
      target: this.target,
      layers: [
        this.darkModeMap
      ],
      view: new View({
        center: fromLonLat([this.lon, this.lat]),
        zoom: this.zoom
      })
    }); //////////////////////////////


    // Pre-creo uno Style per ogni cluster: la style function li
    // riusa per ogni feature evitando allocazioni durante il render.
    for (let i = 0; i < 10; i++) {
      this.clusterStyles[i] = new Style({
        fill: new Fill({
          color: this.clusterService.getColor(i)
        })
      });
    }

    // Un unico VectorImageLayer per tutte le ~10k feature:
    // rasterizza su canvas off-screen, quindi pan/zoom traslano
    // l'immagine cacheata invece di rifare il rendering vettoriale
    // di 10 layer separati. La style function discrimina i cluster
    // e applica il filtro corrente (-1 = tutti).
    this.clusterLayer = new VectorImageLayer({
      source: new VectorSource({
        features: new GeoJSON().readFeatures(this.products, {
          dataProjection: 'EPSG:3857',
          featureProjection: 'EPSG:3857',
        }),
      }),
      style: (feature) => {
        const cluster = Number(feature.get('CLUSTER'));
        if (this.currentClusterFilter !== -1 && cluster !== this.currentClusterFilter) {
          return undefined;
        }
        return this.clusterStyles[cluster];
      },
    });

    this.map.addLayer(this.clusterLayer);

    const context = this;
    this.map.on('singleclick', function (evt) {
      const coordinate = evt.coordinate;
      const pixel = evt.pixel;

      context.mostraInfoLayer(pixel);

      // OTTENERE LAT E LON
      // console.info(evt.pixel);
      // console.info(context.map.getPixelFromCoordinate(evt.coordinate));
      // console.info(toLonLat(evt.coordinate));
      var coords = toLonLat(evt.coordinate);
      var lat = coords[1];
      var lon = coords[0];
      var locTxt = "Latitude: " + lat + " Longitude: " + lon;
      // console.log("Lon: " + lon + ",\nLat: " + lat);
    })
  }


  createLayer(singlePolygonJSON: any) {
    this.onePolygonLayer = new VectorLayer({
      source: new VectorSource({
        features: new GeoJSON().readFeatures(JSON.stringify(singlePolygonJSON).replace(/\\/g, ""))
      }),
      style: new Style({
        stroke: new Stroke({
          color: 'rgb(0,0,0)'
        })
      }),
    })
  }


  selectedFeature: any;
  selectedFeatureIndex!: number;
  lastSelectedFeatureIndex: number = 0;

  onePolygonLayer: any;
  mostraInfoLayer(pixel: any) {
    var features: any = [];

    var ctx = this;
    this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
      features.push(feature);
    });

    // selectedFeatureLayer

    // IMPORTANTE! OTTENERE LA FEATURE DALL'INDEX OTTENUTO DAL
    // FOR SOPRA:
    // console.log(JSON.parse(JSON.stringify(this.products)).features[this.selectedFeatureIndex]);

    if (features.length !== 0 && features[0].values_.AREA) {

      // this.map.addLayer(this.onePolygonLayer);

      // OTTENERE L'INDEX DELLA FEATURE CLICCATA
      var GeoJSON = JSON.parse(JSON.stringify(this.products));

      for (var index in GeoJSON.features)
        if (GeoJSON.features[index].properties.AREA == features[0].values_.AREA)
          this.selectedFeatureIndex = Number.parseInt(index);

      console.log('[Click] Feature index:', this.selectedFeatureIndex, '| AREA:', features[0].values_.AREA, '| CLUSTER:', features[0].values_.CLUSTER);

      if (this.selectedFeatureIndex != this.lastSelectedFeatureIndex) {
        // CLICK SUL VUOTO
        var keys: string[] = [], values: number[] = [];

        this.clusterService.changeKeysValues(keys, values);
        this.clusterService.changeDataEvent.emit({ keys, values });

        this.clusterService.hoverFirstImage = false;


        // CLICK SU UN'AREA
        this.clusterService.urlArray = [];
        this.clusterService.commentArray = [];
          this.clusterService.cloudyArray = [];
          var url = `${environment.apiUrl}/test/image?index=${this.selectedFeatureIndex}`;
          var listaUrl = new Object(this.httpRequest.getFile(url).subscribe((data: any) => {
            console.log('[/test/image] Risposta:', data);
            Object.keys(data).forEach((key) => {
              this.clusterService.urlArray.push(data[key].immagine || '');
              this.clusterService.commentArray.push(data[key].commento || '');
              this.clusterService.cloudyArray.push(!!data[key].cloudy);
            this.clusterService.currentCropName = "" + data[key].commento;
          });
          // showChart chiamato UNA VOLTA dopo il forEach:
          // evita 12 emissioni rapide di changeDataEvent che causano
          // una race condition in ApexCharts
          this.showChart(features);
        }));
      }

      this.lastSelectedFeatureIndex = this.selectedFeatureIndex;
      // this.clusterService.urlArray
    } else {
      // CLICK SUL VUOTO
      var keys: string[] = [], values: number[] = [];

      this.clusterService.changeKeysValues(keys, values);
      this.clusterService.changeDataEvent.emit({ keys, values });

      this.clusterService.hoverFirstImage = false;
    }
  }

  showChart(features: any) {
    this.clusterService.currentColor = features[0].CLUSTER;
    this.selectedFeature = features;
    this.clusterService.hoverFirstImage = false;
    this.clusterService.currentFeature = features;

    // Deriva il nome coltura dal CLUSTER (non dal campo commento che contiene ID casuali)
    const cluster = Number(features[0].values_?.CLUSTER ?? features[0].CLUSTER ?? 0);
    this.clusterService.currentCropName = this.getCropName(cluster);

    var new_keys: any[] = [];
    for (var i = 0; i < 12; i++) {
      new_keys.push(Object.keys(features[0].values_)[i + 1]);
    }

    var new_values: any[] = [];
    for (var i = 0; i < 12; i++) {
      const raw = features[0].values_[Object.keys(features[0].values_)[i + 1]];
      new_values.push(Number(raw?.valore ?? raw));
    }

    // Popola urlArray e commentArray dai dati embedded nel GeoJSON
    this.clusterService.urlArray = [];
    this.clusterService.commentArray = [];
    this.clusterService.cloudyArray = [];
    for (var i = 0; i < 12; i++) {
      const raw = features[0].values_[Object.keys(features[0].values_)[i + 1]];
      this.clusterService.urlArray.push(raw?.immagine ?? '');
      this.clusterService.commentArray.push(raw?.commento ?? '');
      this.clusterService.cloudyArray.push(!!raw?.cloudy);
    }

    var data = this.filterData(new_values, new_keys);
    console.log('[Map] showChart emit | vals[0]=', data.new_values[0]);

    this.clusterService.keys = data.new_key;
    this.clusterService.values = data.new_values;

    this.clusterService.changeDataEvent.emit(data);
  }


  filterMap(cluster: number) {
    // Se seleziono il cluster gia' selezionato non rifaccio nulla.
    if (cluster !== this.lastCluster) {
      // Aggiorno il filtro letto dalla style function e forzo un
      // ridisegno del layer: -1 mostra tutto, altrimenti solo il cluster scelto.
      this.currentClusterFilter = cluster;
      if (this.clusterLayer) {
        this.clusterLayer.changed();
      }
      this.lastCluster = cluster;
    }
  }

  public setSize(): void {
    this.altezzaSchermo = window.innerHeight;
    if (this.mapOutput) {
      const styles = this.mapOutput.style;
      styles.height = (this.altezzaSchermo + 'px') || DEFAULT_HEIGHT;
      styles.width = coerceCssPixelValue(this.width) || DEFAULT_WIDTH;
    }
  }

  // Mostra tutti i cluster (filtro disattivato).
  geojsonFilterAllLayer() {
    this.currentClusterFilter = -1;
    if (this.clusterLayer) {
      this.clusterLayer.changed();
    }
  }

  filterData(values: any, keys: any) {
    var new_key: string[] = [];
    for (var i = 0; i < 12; i++) {
      if (!keys[i].includes('me')) {
        var gg = keys[i].substring(6, 8), mm = keys[i].substring(4, 6), aa = keys[i].substring(0, 4);
        new_key.push(gg + '/' + mm + '/' + aa);
      } else {
        var gg = keys[i].substring(6, 7), mm = keys[i].substring(4, 6), aa = keys[i].substring(0, 4);
        new_key.push(gg + 'X/' + mm + '/' + aa);
      }
    }

    var new_values: number[] = [];
    for (var i = 0; i < 12; i++) {
      new_values.push(values[i]);
    }

    return { new_key, new_values };
  }

  changeHoverValueMessage(value: number) {
    var tipoTerreno = this.selectedFeature[0].values_[Object.keys(this.selectedFeature[0].values_)[value + 1]].commento;
    var urlImmagine = this.selectedFeature[0].values_[Object.keys(this.selectedFeature[0].values_)[value + 1]].immagine;
    this.clusterService.changeSidebarMessages.emit([tipoTerreno, urlImmagine]);
  }
}

const cssUnitPattern = /([A-Za-z%])$/;

function coerceCssPixelValue(value: any): string {
  if (value == null) {
    return '';
  }

  return cssUnitPattern.test(value) ? value : '${value}px'
}